const AlertIcon = ({ messagelength, header }) => {
  const noAlertSvg = (
    <svg
      width="48"
      height="44"
      viewBox="0 0 48 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.152 33.664H22.856C22.5246 33.664 22.256 33.9326 22.256 34.264V36.56C22.256 36.8914 22.5246 37.16 22.856 37.16H25.152C25.4834 37.16 25.752 36.8914 25.752 36.56V34.264C25.752 33.9326 25.4834 33.664 25.152 33.664Z"
        fill="#CCDBF0"
        fillOpacity="0.72"
      />
      <path
        d="M22.2607 22.704V15.288C22.2607 15.1493 22.3152 15.0162 22.4125 14.9174C22.5098 14.8187 22.642 14.7621 22.7807 14.76H25.2287C25.3673 14.7621 25.4996 14.8187 25.5969 14.9174C25.6942 15.0162 25.7487 15.1493 25.7487 15.288V22.704L25.1087 30.88C25.0986 31.013 25.0385 31.1372 24.9406 31.2278C24.8426 31.3183 24.7141 31.3684 24.5807 31.368H23.4367C23.3041 31.3682 23.1765 31.3179 23.0799 31.2272C22.9832 31.1365 22.9248 31.0123 22.9167 30.88L22.2607 22.704Z"
        fill="#CCDBF0"
        fillOpacity="0.72"
      />
      <path
        d="M46.8214 43.6H1.1786C0.971068 43.5987 0.767497 43.5413 0.588235 43.4334C0.408973 43.3256 0.260299 43.1712 0.157074 42.9855C0.053848 42.7999 -0.000313966 42.5896 1.36909e-06 42.3756C0.000316704 42.1616 0.0550986 41.9514 0.158871 41.7661L22.9724 1.01266C23.0763 0.826436 23.2261 0.67175 23.4065 0.564192C23.5869 0.456634 23.7916 0.400002 24 0.400002C24.2084 0.400002 24.4131 0.456634 24.5935 0.564192C24.7739 0.67175 24.9237 0.826436 25.0276 1.01266L47.8411 41.7661C47.9449 41.9514 47.9997 42.1616 48 42.3756C48.0003 42.5896 47.9461 42.7999 47.8429 42.9855C47.7397 43.1712 47.591 43.3256 47.4118 43.4334C47.2325 43.5413 47.0289 43.5987 46.8214 43.6ZM4.60142 40.3397H43.3986L24 5.69931L4.60142 40.3397Z"
        fill="#CCDBF0"
        fillOpacity="0.72"
      />
    </svg>
  );

  const alertSVg = (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.58824 53.0334C6.7675 53.1413 6.97107 53.1987 7.1786 53.2H52.8214C53.0289 53.1987 53.2325 53.1413 53.4118 53.0334C53.591 52.9256 53.7397 52.7712 53.8429 52.5855C53.9461 52.3999 54.0003 52.1895 54 51.9756C53.9997 51.7616 53.9449 51.5514 53.8411 51.3661L46.3031 37.9004C44.8634 37.8295 43.4806 37.5396 42.1877 37.0631L49.3986 49.9397H10.6014L30 15.2993L33.3484 21.2785C33.627 19.8733 34.1173 18.5437 34.785 17.3246L31.0276 10.6127C30.9237 10.4264 30.7739 10.2717 30.5935 10.1642C30.4131 10.0566 30.2084 10 30 10C29.7916 10 29.5869 10.0566 29.4065 10.1642C29.2261 10.2717 29.0763 10.4264 28.9724 10.6127L6.15887 51.3661C6.0551 51.5514 6.00032 51.7616 6 51.9756C5.99969 52.1895 6.05385 52.3999 6.15708 52.5855C6.2603 52.7712 6.40897 52.9256 6.58824 53.0334ZM28.2607 32.304V24.888C28.2607 24.7493 28.3152 24.6162 28.4125 24.5174C28.5098 24.4187 28.642 24.3621 28.7807 24.36H31.2287C31.3673 24.3621 31.4996 24.4187 31.5969 24.5174C31.6942 24.6162 31.7487 24.7493 31.7487 24.888V32.304L31.1087 40.48C31.0986 40.613 31.0385 40.7372 30.9406 40.8278C30.8426 40.9183 30.7141 40.9684 30.5807 40.968H29.4367C29.3041 40.9682 29.1765 40.9179 29.0799 40.8272C28.9832 40.7365 28.9248 40.6123 28.9167 40.48L28.2607 32.304ZM31.152 43.264H28.856C28.5246 43.264 28.256 43.5326 28.256 43.864V46.16C28.256 46.4914 28.5246 46.76 28.856 46.76H31.152C31.4834 46.76 31.752 46.4914 31.752 46.16V43.864C31.752 43.5326 31.4834 43.264 31.152 43.264Z"
        fill="#CCDBF0"
        fillOpacity="0.72"
      />
      <circle
        cx="47"
        cy="24.0003"
        r="11.308"
        transform="rotate(-0.340625 47 24.0003)"
        fill="#EB0A37"
      />
    </svg>
  );
  return (
    <>
      {messagelength === 0 ? noAlertSvg : alertSVg}
      <span className="text-light-2 text-xs pt-2 font-scaniacondensed">
        {header}
      </span>
    </>
  );
};

export default AlertIcon;
